/* ============================================================
   BLUE SALON — Gift builder page
   Step 1: choose a gift box. Step 2: choose gifts to fill it,
   filtered by the hotyon search API's own "For who" / "Collection"
   / "Brand" facets (each has a fixed id on the gifts collection).
   Loaded only by sections/gift-builder.liquid (page.gift template).
   ============================================================ */
(function () {
  "use strict";

  function storefrontUrl(path) {
    if (window.BS && typeof window.BS.storefrontUrl === "function") return window.BS.storefrontUrl(path);
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (shopRoot || "/") + String(path || "").replace(/^\//, "");
  }

  var giftI18n = (window.BS_I18N && window.BS_I18N.gift_builder) || {};
  function giftText(key, fallback, replacements) {
    var value = giftI18n[key] || fallback;
    Object.keys(replacements || {}).forEach(function (token) {
      value = value.split(token).join(replacements[token]);
    });
    return value;
  }

  var FACET_FOR_WHO = "918940458";
  var FACET_COLLECTION = "156437485";
  var FACET_BRAND = "457140619";

  function formatMoney(cents) {
    var locale = document.documentElement.lang || "en";
    var amount = (cents / 100).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "";
    return (currency ? currency + " " : "") + amount;
  }

  function imageSrc(url) {
    if (!url) return "";
    return url.indexOf("//") === 0 ? "https:" + url : url;
  }

  function initGiftBuilder(root) {
    if (!root || root.dataset.giftInited) return;
    root.dataset.giftInited = "true";

    var boxes = Array.prototype.slice.call(root.querySelectorAll("[data-gift-box]"));
    var stateEl = root.querySelector("[data-gift-summary-state]");
    var lineEl = root.querySelector("[data-gift-summary-line]");
    var thumbEl = root.querySelector("[data-gift-summary-thumb]");
    var titleEl = root.querySelector("[data-gift-summary-title]");
    var priceEl = root.querySelector("[data-gift-summary-price]");
    var removeBtn = root.querySelector("[data-gift-summary-remove]");
    var progressEl = root.querySelector("[data-gift-summary-progress]");
    var itemsEl = root.querySelector("[data-gift-summary-items]");
    var nextBtn = root.querySelector("[data-gift-summary-next]");
    var nextLabelEl = root.querySelector("[data-gift-summary-next-label]");
    var stepEls = Array.prototype.slice.call(root.querySelectorAll("[data-gift-steps] [data-step]"));
    var stepContents = Array.prototype.slice.call(root.querySelectorAll("[data-step-content]"));

    var giftsApiUrl = root.getAttribute("data-gifts-api-url");
    var collectionId = root.getAttribute("data-gifts-collection-id") || "";
    var productLimit = parseInt(root.getAttribute("data-gifts-product-limit"), 10) || 60;

    var gridEl = root.querySelector("[data-gift-products-grid]");
    var emptyEl = root.querySelector("[data-gift-products-empty]");
    var skeletonHtml = gridEl ? gridEl.innerHTML : "";
    var filterEls = {
      for_who: root.querySelector('[data-gift-filter="for_who"]'),
      collection: root.querySelector('[data-gift-filter="collection"]'),
      brand: root.querySelector('[data-gift-filter="brand"]')
    };

    var includeCardCheckbox = root.querySelector("[data-gift-include-card]");
    var hideInvoiceCheckbox = root.querySelector("[data-gift-hide-invoice]");
    var messageFieldsEl = root.querySelector("[data-gift-message-fields]");
    var recipientInput = root.querySelector("[data-gift-recipient]");
    var messageInput = root.querySelector("[data-gift-message]");
    var fromInput = root.querySelector("[data-gift-from]");

    var reviewCountEl = root.querySelector("[data-gift-review-count]");
    var reviewLinesEl = root.querySelector("[data-gift-review-lines]");
    var reviewPriceEl = root.querySelector("[data-gift-review-price]");
    var reviewSubtotalEl = root.querySelector("[data-gift-review-subtotal]");
    var reviewTotalEl = root.querySelector("[data-gift-review-total]");
    var reviewEditBtn = root.querySelector("[data-gift-review-edit]");
    var reviewDeleteBtn = root.querySelector("[data-gift-review-delete]");
    var reviewErrorEl = root.querySelector("[data-gift-review-error]");
    var checkoutBtn = root.querySelector("[data-gift-checkout]");

    if (!boxes.length || !nextBtn) return;

    var currentStep = 1;
    var maxStepReached = 1;
    var selectedBox = null;
    var addedItems = {};
    var addedOrder = [];
    var giftsLoaded = false;

    function setStep(step) {
      currentStep = step;
      if (step > maxStepReached) maxStepReached = step;
      stepContents.forEach(function (el) {
        el.hidden = el.getAttribute("data-step-content") !== String(step);
      });
      stepEls.forEach(function (el) {
        var n = parseInt(el.getAttribute("data-step"), 10);
        el.classList.toggle("completed", n < step);
        el.classList.toggle("active", n === step);
      });
      nextBtn.hidden = step === 4;
      updateNextButton();
      if (step === 2 && !giftsLoaded) loadGifts();
      if (step === 4) renderReview();
    }

    function canAdvanceFromStep2() {
      var min = selectedBox ? selectedBox.min : 0;
      return !!selectedBox && addedOrder.length >= min;
    }

    function canAdvanceFromStep3() {
      if (!includeCardCheckbox || !includeCardCheckbox.checked) return true;
      return !!(recipientInput && recipientInput.value.trim() &&
        messageInput && messageInput.value.trim() &&
        fromInput && fromInput.value.trim());
    }

    function updateNextButton() {
      if (currentStep === 2) {
        var max = selectedBox ? selectedBox.max : 0;
        if (nextLabelEl) nextLabelEl.textContent = giftText("next_count", "Next (" + addedOrder.length + "/" + max + ")", { "__COUNT__": addedOrder.length, "__MAX__": max });
        nextBtn.disabled = !canAdvanceFromStep2();
      } else if (currentStep === 3) {
        if (nextLabelEl) nextLabelEl.textContent = giftText("review", "Review");
        nextBtn.disabled = !canAdvanceFromStep3();
      } else {
        if (nextLabelEl) nextLabelEl.textContent = nextBtn.getAttribute("data-default-label") || giftText("next", "Next");
        nextBtn.disabled = !selectedBox;
      }
    }

    if (!nextBtn.getAttribute("data-default-label") && nextLabelEl) {
      nextBtn.setAttribute("data-default-label", nextLabelEl.textContent);
    }
    var checkoutDefaultLabel = checkoutBtn ? checkoutBtn.textContent.trim() : "Check Out";

    function selectBox(box) {
      boxes.forEach(function (b) { b.classList.remove("is-selected"); });
      box.classList.add("is-selected");

      var label = box.getAttribute("data-box-label") || "";
      var price = parseFloat(box.getAttribute("data-box-price")) || 0;
      var min = parseInt(box.getAttribute("data-box-min"), 10) || 0;
      var max = parseInt(box.getAttribute("data-box-max"), 10) || 0;
      var variantId = box.getAttribute("data-box-variant-id") || "";
      var img = box.querySelector(".gift-box-image img");

      selectedBox = {
        label: label,
        price: price,
        min: min,
        max: max,
        variantId: variantId,
        image: img ? (img.currentSrc || img.src) : ""
      };
      addedItems = {};
      addedOrder = [];

      if (stateEl) {
        stateEl.textContent = stateEl.getAttribute("data-filled-label") || giftText("state_filled", "has items");
        stateEl.classList.add("is-filled");
      }

      if (lineEl) lineEl.hidden = false;
      if (titleEl) titleEl.textContent = label;
      if (priceEl) priceEl.textContent = formatMoney(price * 100);
      if (thumbEl) {
        thumbEl.textContent = "";
        if (img) {
          var clone = document.createElement("img");
          clone.src = img.currentSrc || img.src;
          clone.alt = label;
          thumbEl.appendChild(clone);
        }
      }

      if (progressEl) {
        if (max > 0) {
          progressEl.hidden = false;
          progressEl.textContent = giftText("progress", "0 of " + max + " items (add minimum " + min + ")", { "__COUNT__": 0, "__MAX__": max, "__MIN__": min });
        } else {
          progressEl.hidden = true;
        }
      }

      renderSidebarItems();
      syncGridButtons();
      updateNextButton();
    }

    function clearSelection() {
      boxes.forEach(function (b) { b.classList.remove("is-selected"); });
      selectedBox = null;
      addedItems = {};
      addedOrder = [];
      maxStepReached = 1;

      if (stateEl) {
        stateEl.textContent = stateEl.getAttribute("data-empty-label") || giftText("state_empty", "empty");
        stateEl.classList.remove("is-filled");
      }
      if (lineEl) lineEl.hidden = true;
      if (progressEl) progressEl.hidden = true;

      renderSidebarItems();
      syncGridButtons();
      setStep(1);
    }

    function renderSidebarItems() {
      if (!itemsEl) return;
      itemsEl.textContent = "";
      addedOrder.forEach(function (id) {
        var item = addedItems[id];
        var li = document.createElement("li");
        li.className = "gift-summary-item";

        var thumb = document.createElement("span");
        thumb.className = "gift-summary-thumb";
        if (item.image) {
          var img = document.createElement("img");
          img.src = item.image;
          img.alt = item.title;
          thumb.appendChild(img);
        }
        li.appendChild(thumb);

        var info = document.createElement("span");
        info.className = "gift-summary-info";
        var title = document.createElement("span");
        title.className = "gift-summary-title";
        title.textContent = item.title;
        var price = document.createElement("span");
        price.className = "gift-summary-price";
        price.textContent = formatMoney(item.price * 100);
        info.appendChild(title);
        info.appendChild(price);
        li.appendChild(info);

        var remove = document.createElement("button");
        remove.type = "button";
        remove.className = "gift-summary-remove";
        remove.setAttribute("aria-label", giftText("remove", "Remove"));
        remove.innerHTML = "&times;";
        remove.addEventListener("click", function () { toggleItem(item); });
        li.appendChild(remove);

        itemsEl.appendChild(li);
      });

      if (progressEl && selectedBox && selectedBox.max > 0) {
        progressEl.textContent = giftText("progress", addedOrder.length + " of " + selectedBox.max + " items (add minimum " + selectedBox.min + ")", { "__COUNT__": addedOrder.length, "__MAX__": selectedBox.max, "__MIN__": selectedBox.min });
      }
    }

    function reviewLine(title, sub, price, image) {
      var li = document.createElement("li");
      li.className = "gift-review-line";

      var thumb = document.createElement("span");
      thumb.className = "gift-review-line-thumb";
      if (image) {
        var img = document.createElement("img");
        img.src = image;
        img.alt = title;
        thumb.appendChild(img);
      }
      li.appendChild(thumb);

      var info = document.createElement("span");
      info.className = "gift-review-line-info";
      var titleEl2 = document.createElement("span");
      titleEl2.className = "gift-review-line-title";
      titleEl2.textContent = title;
      info.appendChild(titleEl2);
      if (sub) {
        var subEl = document.createElement("span");
        subEl.className = "gift-review-line-sub";
        subEl.textContent = sub;
        info.appendChild(subEl);
      }
      li.appendChild(info);

      var qty = document.createElement("span");
      qty.className = "gift-review-line-qty";
      qty.textContent = "x1";
      li.appendChild(qty);

      var priceEl2 = document.createElement("span");
      priceEl2.className = "gift-review-line-price";
      priceEl2.textContent = formatMoney(price * 100);
      li.appendChild(priceEl2);

      return li;
    }

    function renderReview() {
      if (reviewErrorEl) reviewErrorEl.hidden = true;
      if (reviewCountEl) reviewCountEl.textContent = giftText("items_count", "Items: " + addedOrder.length, { "__COUNT__": addedOrder.length });

      var total = selectedBox ? selectedBox.price : 0;

      if (reviewLinesEl) {
        reviewLinesEl.textContent = "";
        if (selectedBox) {
          reviewLinesEl.appendChild(reviewLine(selectedBox.label, giftText("gift_box", "Gift Box"), selectedBox.price, selectedBox.image));
        }
        addedOrder.forEach(function (id) {
          var item = addedItems[id];
          total += item.price;
          reviewLinesEl.appendChild(reviewLine(item.title, "", item.price, item.image));
        });
      }

      if (reviewPriceEl) reviewPriceEl.textContent = formatMoney(total * 100);
      if (reviewSubtotalEl) reviewSubtotalEl.textContent = formatMoney(total * 100);
      if (reviewTotalEl) reviewTotalEl.textContent = formatMoney(total * 100);
    }

    function checkout() {
      if (!checkoutBtn || checkoutBtn.disabled) return;
      checkoutBtn.disabled = true;
      checkoutBtn.textContent = giftText("processing", "Processing…");
      if (reviewErrorEl) reviewErrorEl.hidden = true;

      var lineItems = [];
      if (selectedBox && selectedBox.variantId) {
        lineItems.push({
          id: selectedBox.variantId,
          quantity: 1,
          properties: { "Gift Box": selectedBox.label }
        });
      }
      addedOrder.forEach(function (id) {
        var item = addedItems[id];
        if (!item.variantId) return;
        lineItems.push({
          id: item.variantId,
          quantity: 1,
          properties: { "Gift Box": selectedBox ? selectedBox.label : "" }
        });
      });

      if (!lineItems.length) {
        checkoutBtn.disabled = false;
        checkoutBtn.textContent = checkoutDefaultLabel;
        if (reviewErrorEl) {
          reviewErrorEl.hidden = false;
          reviewErrorEl.textContent = giftText("empty_cart_error", "Your gift box has no items that can be added to the cart.");
        }
        return;
      }

      var includeCard = !includeCardCheckbox || includeCardCheckbox.checked;
      var attributes = {
        "Gift Box": selectedBox ? selectedBox.label : "",
        "Gift Wrap Invoice Hidden": (hideInvoiceCheckbox && hideInvoiceCheckbox.checked) ? "Yes" : "No",
        "Gift Card Included": includeCard ? "Yes" : "No"
      };
      if (includeCard) {
        attributes["Gift Recipient"] = recipientInput ? recipientInput.value.trim() : "";
        attributes["Gift Message"] = messageInput ? messageInput.value.trim() : "";
        attributes["Gift From"] = fromInput ? fromInput.value.trim() : "";
      }

      fetch(storefrontUrl("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: lineItems })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw new Error(err.message || giftText("add_failed", "Could not add items to cart.")); });
          return res.json();
        })
        .then(function () {
          return fetch(storefrontUrl("cart/update.js"), {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ attributes: attributes })
          });
        })
        .then(function () {
          window.location.href = "/checkout";
        })
        .catch(function (err) {
          checkoutBtn.disabled = false;
          checkoutBtn.textContent = checkoutDefaultLabel;
          if (reviewErrorEl) {
            reviewErrorEl.hidden = false;
            reviewErrorEl.textContent = err.message || giftText("generic_error", "Something went wrong. Please try again.");
          }
        });
    }

    function syncGridButtons() {
      if (!gridEl) return;
      var atMax = !!(selectedBox && selectedBox.max > 0 && addedOrder.length >= selectedBox.max);
      Array.prototype.forEach.call(gridEl.querySelectorAll("[data-gift-add]"), function (btn) {
        var id = btn.getAttribute("data-product-id");
        var added = !!addedItems[id];
        btn.classList.toggle("is-added", added);
        btn.textContent = added ? giftText("remove", "Remove") : giftText("add_to_box", "Add to Box");
        btn.disabled = !added && atMax;
      });
    }

    function toggleItem(item) {
      if (addedItems[item.id]) {
        delete addedItems[item.id];
        addedOrder = addedOrder.filter(function (id) { return id !== item.id; });
      } else {
        if (selectedBox && selectedBox.max > 0 && addedOrder.length >= selectedBox.max) return;
        addedItems[item.id] = item;
        addedOrder.push(item.id);
      }
      renderSidebarItems();
      syncGridButtons();
      updateNextButton();
    }

    function buildFacetFilters() {
      var filters = {};
      if (filterEls.for_who && filterEls.for_who.value) filters[FACET_FOR_WHO] = ["tags", [filterEls.for_who.value]];
      if (filterEls.collection && filterEls.collection.value) filters[FACET_COLLECTION] = ["tags", [filterEls.collection.value]];
      if (filterEls.brand && filterEls.brand.value) filters[FACET_BRAND] = ["vendor", [filterEls.brand.value]];
      return filters;
    }

    function requestUrl(includeFilters) {
      var url = giftsApiUrl + "&collection=" + encodeURIComponent(collectionId) + "&skip=0&take=" + productLimit;
      if (includeFilters) {
        var filters = buildFacetFilters();
        if (Object.keys(filters).length) url += "&facetFilters=" + encodeURIComponent(JSON.stringify(filters));
      }
      return url;
    }

    function populateFilterOptions(facets) {
      var byId = {};
      (facets || []).forEach(function (f) { byId[f.id] = f; });

      function fill(select, facet) {
        if (!select || !facet) return;
        (facet.labels || []).forEach(function (l) {
          var opt = document.createElement("option");
          opt.value = l.label;
          opt.textContent = (l.label || "").trim() + " (" + l.value + ")";
          select.appendChild(opt);
        });
      }

      fill(filterEls.for_who, byId[FACET_FOR_WHO]);
      fill(filterEls.collection, byId[FACET_COLLECTION]);
      fill(filterEls.brand, byId[FACET_BRAND]);
    }

    function renderProductGrid(items) {
      if (!gridEl) return;
      gridEl.textContent = "";

      if (emptyEl) emptyEl.hidden = !!items.length;
      if (!items.length) return;

      items.forEach(function (product) {
        var variant = (product.variants && product.variants[0]) || {};
        var image = product.images && product.images[0] ? imageSrc(product.images[0].url) : "";
        var item = {
          id: String(product.id),
          variantId: variant.id,
          title: product.title,
          price: variant.price || 0,
          image: image
        };

        var card = document.createElement("div");
        card.className = "gift-product-card";

        var imgWrap = document.createElement("div");
        imgWrap.className = "gift-product-image";
        if (image) {
          var img = document.createElement("img");
          img.src = image;
          img.alt = product.title;
          img.loading = "lazy";
          imgWrap.appendChild(img);
        }
        card.appendChild(imgWrap);

        var vendor = document.createElement("div");
        vendor.className = "gift-product-vendor";
        vendor.textContent = product.vendor || "";
        card.appendChild(vendor);

        var title = document.createElement("div");
        title.className = "gift-product-title";
        title.textContent = product.title;
        card.appendChild(title);

        var price = document.createElement("div");
        price.className = "gift-product-price";
        price.textContent = formatMoney(item.price * 100);
        card.appendChild(price);

        var addBtn = document.createElement("button");
        addBtn.type = "button";
        addBtn.className = "bs-btn bs-btn-primary gift-product-add";
        addBtn.setAttribute("data-gift-add", "");
        addBtn.setAttribute("data-product-id", item.id);
        addBtn.textContent = giftText("add_to_box", "Add to Box");
        addBtn.addEventListener("click", function () { toggleItem(item); });
        card.appendChild(addBtn);

        gridEl.appendChild(card);
      });

      syncGridButtons();
    }

    function loadGifts() {
      if (!giftsApiUrl) return;
      giftsLoaded = true;

      fetch(requestUrl(false))
        .then(function (res) { return res.json(); })
        .then(function (result) {
          var data = (result && result.data) || {};
          populateFilterOptions(data.facets);
          renderProductGrid(data.items || []);
        })
        .catch(function () {
          giftsLoaded = false;
          if (gridEl) gridEl.textContent = "";
          if (emptyEl) {
            emptyEl.hidden = false;
            emptyEl.textContent = giftText("load_failed", "Something went wrong loading gifts. Please try again.");
          }
        });
    }

    function applyFilters() {
      if (!giftsApiUrl) return;
      if (gridEl) gridEl.innerHTML = skeletonHtml;
      if (emptyEl) emptyEl.hidden = true;

      fetch(requestUrl(true))
        .then(function (res) { return res.json(); })
        .then(function (result) {
          var data = (result && result.data) || {};
          renderProductGrid(data.items || []);
        })
        .catch(function () {
          if (gridEl) gridEl.textContent = "";
          if (emptyEl) {
            emptyEl.hidden = false;
            emptyEl.textContent = giftText("load_failed", "Something went wrong loading gifts. Please try again.");
          }
        });
    }

    boxes.forEach(function (box) {
      box.addEventListener("click", function () {
        if (box.classList.contains("is-selected")) return;
        selectBox(box);
      });
    });

    if (removeBtn) removeBtn.addEventListener("click", clearSelection);

    Object.keys(filterEls).forEach(function (key) {
      if (filterEls[key]) filterEls[key].addEventListener("change", applyFilters);
    });

    if (includeCardCheckbox && messageFieldsEl) {
      includeCardCheckbox.addEventListener("change", function () {
        messageFieldsEl.classList.toggle("is-disabled", !includeCardCheckbox.checked);
        updateNextButton();
      });
    }
    [recipientInput, messageInput, fromInput].forEach(function (input) {
      if (input) input.addEventListener("input", updateNextButton);
    });

    stepEls.forEach(function (el) {
      el.addEventListener("click", function () {
        var n = parseInt(el.getAttribute("data-step"), 10);
        if (n === currentStep || n > maxStepReached) return;
        setStep(n);
      });
    });

    nextBtn.addEventListener("click", function () {
      if (nextBtn.disabled) return;
      setStep(currentStep + 1);
    });

    if (reviewEditBtn) reviewEditBtn.addEventListener("click", function () { setStep(2); });
    if (reviewDeleteBtn) reviewDeleteBtn.addEventListener("click", clearSelection);
    if (checkoutBtn) checkoutBtn.addEventListener("click", checkout);

    setStep(1);
  }

  function initAll() {
    document.querySelectorAll("[data-gift-builder]").forEach(initGiftBuilder);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
